import api from "./api";

const bankService = {
  // ── Auth ──
  login: (data) => api.post("/bank/login", data),
  listPublicBanks: () => api.get("/bank/public/banks"),
  register: async (data) => {
    const res = await api.post("/bank/register", data);
    return res.data;
  },
  resendRegistrationOtp: (registrationId) =>
    api.post("/bank/register/resend-otp", { registrationId }),
  verifyRegistrationOtp: (registrationId, otp) =>
    api.post("/bank/register/verify-otp", { registrationId, otp }),
  getInviteByToken: (token) => api.get(`/bank/invite/${token}`),

  // ── S3 Upload pipeline ──
  presignUpload: (data) => api.post("/bank/uploads/presign", data),
  proxyUpload: (formData) =>
    api.post("/bank/uploads/proxy", formData, {
      timeout: 0,
      headers: { "Content-Type": "multipart/form-data" },
    }),
  completeUpload: (data) => api.post("/bank/uploads/complete", data),
  listUploads: (params) => api.get("/bank/uploads", { params }),
  getUploadBatch: (batchId) => api.get(`/bank/uploads/${batchId}`),

  // ── Records ──
  getRecords: (params) => api.get("/bank/records", { params }),
  getRecord: (id) => api.get(`/bank/records/${id}`),
  deleteRecord: (id) => api.delete(`/bank/records/${id}`),
  createRecord: (data) => api.post("/bank/records", data),
  deleteBatchRecords: (batchId) => api.delete(`/bank/uploads/${batchId}/records`),

  // ── Persons (Bank Admin only) ──
  getPersons: (params) => api.get("/bank/persons", { params }),
  createPerson: async (data) => {
    const res = await api.post("/bank/persons", data);
    return res.data;
  },
  resendPersonOtp: async (registrationId) => {
    const res = await api.post("/bank/persons/resend-otp", { registrationId });
    return res.data;
  },
  verifyPersonOtp: (registrationId, otp) =>
    api.post("/bank/persons/verify-otp", { registrationId, otp }),
  togglePerson: (id) => api.patch(`/bank/persons/${id}/toggle`),

  // ── Tracing ──
  getTracingView: (params) => api.get("/bank/tracing", { params }),
  listLinkedAgencies: () => api.get("/bank/linked-agencies"),
  getTraceCases: (params) => api.get("/bank/trace-cases", { params }),
  getTraceCase: (id) => api.get(`/bank/trace-cases/${id}`),

  // ── Repo Admin: linked bank records ──
  getLinkedRecords: (params) => api.get("/bank/repo-records", { params }),
  getLinkedRecord: (id) => api.get(`/bank/repo-records/${id}`),
  assignRecord: (recordId, tracerId) =>
    api.post(`/bank/repo-records/${recordId}/assign`, { tracerId }),

  getAssignedRecords: (params) => api.get("/bank/assigned-records", { params }),
  getAssignedRecord: (id) => api.get(`/bank/assigned-records/${id}`),

  getConnectedBanks: (params) => api.get("/bank/repo-connected-banks", { params }),
  getRepoBankUploads: (params) => api.get("/bank/repo-uploads", { params }),
  getRepoBankUpload: (batchId) => api.get(`/bank/repo-uploads/${batchId}`),

  // ── SSDI ──
  ssdiCreateBank: (data) => api.post("/bank/ssdi/create", data),
  resendSsdiCreateBankOtp: (registrationId) => api.post("/bank/ssdi/create/resend-otp", { registrationId }),
  verifySsdiCreateBankOtp: (registrationId, otp) => api.post("/bank/ssdi/create/verify-otp", { registrationId, otp }),
  ssdiListBanks: (params) => api.get("/bank/ssdi/list", { params }),
  ssdiGetBank: (id) => api.get(`/bank/ssdi/${id}`),
  ssdiDeleteBank: (id) => api.delete(`/bank/ssdi/${id}`),
  ssdiUpdateStatus: (id, data) => api.patch(`/bank/ssdi/${id}/status`, data),
  ssdiRenewBank: (id, data) => api.post(`/bank/ssdi/${id}/renew`, data),

  ssdiCreateLink: (data) => api.post("/bank/ssdi/links", data),
  ssdiListLinks: (params) => api.get("/bank/ssdi/links/all", { params }),
  ssdiDeleteLink: (id) => api.delete(`/bank/ssdi/links/${id}`),
  ssdiLinkedAgencies: (bankId) => api.get(`/bank/ssdi/${bankId}/linked-agencies`),
  ssdiAvailableAgencies: (bankId) =>
    api.get(`/bank/ssdi/${bankId}/available-agencies`),
  ssdiFindEmployeeForLink: (bankId, employeeNumber) =>
    api.get(`/bank/ssdi/${bankId}/employees/by-number`, {
      params: { employeeNumber },
    }),

  ssdiCreateInvite: (data) => api.post("/bank/ssdi/invites", data),
  ssdiListInvites: () => api.get("/bank/ssdi/invites/all"),

  ssdiRunExpiry: () => api.post("/bank/ssdi/run-expiry"),
};

export default bankService;
